import { render, staticRenderFns } from "./AdminGruposComponent.vue?vue&type=template&id=a5e6c97a&"
import script from "./AdminGruposComponent.vue?vue&type=script&lang=js&"
export * from "./AdminGruposComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports